<template lang="pug">
    div
        table.table-auto.border-collapse.border.w-full.bg-white
            table-header(:list="RECIPIENTS_LIST_TABLE_HEADERS")
            tbody
                template(v-for="(item, index) in recipients")
                    tr(:key="item._id")
                        td.border.border-gray-300.w-10.font-light.text-xs.text-center
                            span {{ rowNumber(index) }}                            
                        
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-150
                            user-field(:item="item" field="phone" :context="{ name_space: 'recipients', action: 'EditRecipient' }")
                            .text-xs.text-gray-500.mt-1(v-if="recipientName(item)") {{ recipientName(item) }}          
                        
                        td.p-4.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-100
                            select.w-full.text-xs.border.rounded.border-slate-300.bg-white.py-1(
                                v-if="canChangeGroup"
                                :value="item.group"
                                @change="onGroupChange(item, $event)"
                            )
                                option(v-for="station in stations" :key="station.value" :value="station.value") {{ station.name }}
                            span(v-else-if="stationName(item.group)") {{ stationName(item.group) }}
                            span(v-else) группа не указана

                        td.p-2.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-150
                            recipient-promotion(:item="item")

                        td.p-4.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-100
                            profile-data.w-100.m-auto(:item="item")
                            .text-gray-600.font-medium.text-xs.mt-1(v-if="sentToZup(item)") Данные отправлены в ЗУП
                            .text-red-500.font-medium.text-xs.mt-1(v-else-if="!item.profile") не заполнены
                        td.p-4.text-sm.font-thin.border.border-gray-300.text-center.p-1.w-150
                            template(v-if="!item.sms.length")
                                .text-red-500.font-medium не отправлено
                            template(v-else)
                                .text-sm отправлено
                                sms-status(v-if="isAdmin" :id="item.sms[item.sms.length - 1]")

                        td.p-2.text-sm.font-thin.border.border-gray-300.p-1.w-150
                            gift-checkbox(v-if="isAdmin" :item="item" :context="{ name_space: 'recipients', action: 'EditRecipient' }" field="is_sent")

                        td.p-2.text-sm.font-thin.border.border-gray-300.p-1.w-150
                            approved-checkbox(:item="item")

                        td.text-sm.font-thin.border.border-gray-300.text-center.w-50
                            change-status(v-if="isAdmin" :item="item" :context="{ name_space: 'recipients', action: 'EditRecipient' }")
                        
                        td.text-xs.font-thin.border.border-gray-300.text-center.w-150.p-2
                            div {{ item.created_at | moment("D MMMM YYYY") }}
                            .flex.items-center.justify-center.gap-1.mt-1(v-if="item.created_by")
                                img.w-6.h-6.rounded-full.border.object-cover.flex-shrink-0(
                                    v-if="creatorPhoto(item)"
                                    :src="creatorPhoto(item)"
                                    crossorigin="use-credentials"
                                )
                                .w-6.h-6.rounded-full.border.bg-gray-200.flex-shrink-0(v-else)
                                span.text-xs.text-gray-600 {{ creatorName(item) }}

                        td.text-sm.font-thin.border.border-gray-300.text-center.text-gray-500.w-50
                            delete-item(v-if="isAdmin" :item="item" :context="{ name_space: 'recipients', action: 'DeleteRecipient' }")

        template(v-if="totalPages > 1")
            pagination(
                :totalPages="totalPages"
                :perPage="perPage"
                :currentPage="currentPage"
                @pagechanged="onPageChange"
            )
</template>

<script>
//Components
import TableHeader from '@/components/common/tables/table-header';
import UserImage from '@/components/common/user/user-image';
import UserField from '@/components/common/user/user-field';
import ChangeStatus from '@/components/common/status';
import DeleteItem from '@/components/common/delete';
import UserSelect from '@/components/common/user/user-select';
import SmsStatus from '@/components/common/sms/status';
import Checkbox from '@/components/common/user/user-checkbox';
import ApprovedCheckbox from '@/components/common/user/approved-checkbox';
import ProfileData from './profile';
import RecipientPromotion from './promotion';
import Pagination from '@/components/common/pagination';
//Store
import { RecipientsNameSpace, RecipientsActionTypes, RecipientsGetterTypes, RecipientsMutationTypes } from '@/store/recipients/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
//libs
import moment from 'moment';
//Configs
import { RECIPIENTS_LIST_TABLE_HEADERS, BUTTONS_VALUES, FORMS_LABELS } from '@/configs/views';
import { ICONS } from '@/configs/icons';
import { USER_GROUPS } from '@/configs/user-groups';

export default {
    name: "RecipientsComponent",
    components: {
        'table-header': TableHeader,
        'user-image': UserImage,
        'user-field': UserField,
        'change-status': ChangeStatus,
        'delete-item': DeleteItem,
        'user-select': UserSelect,
        'sms-status': SmsStatus,
        'gift-checkbox': Checkbox,
        'approved-checkbox': ApprovedCheckbox,
        'profile-data': ProfileData,
        'recipient-promotion': RecipientPromotion,
        'pagination': Pagination,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
        search: {
            type: String,
        },
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 0,
        }
    },
    computed: {
        ICONS() {
            return ICONS
        },
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        FORMS_LABELS() {
            return FORMS_LABELS
        },
        RECIPIENTS_LIST_TABLE_HEADERS() {
            return RECIPIENTS_LIST_TABLE_HEADERS
        },
        recipients() {
            return this.$store.getters[`${RecipientsNameSpace}/${RecipientsGetterTypes.GetRecipients}`]
        }, 
        perPage() {
            return this.$store.getters[`${RecipientsNameSpace}/${RecipientsGetterTypes.GetPerPage}`]
        },  
        GROUPS() {
            return USER_GROUPS
        },
        stations() {
            return USER_GROUPS.filter((item) => item.value !== 1)
        },
        canChangeGroup() {
            const role = Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
            return role === 1 || role === 2 || role === 6
        },
        isAdmin() {
            const role = Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
            return role === 1 || role === 2
        },
    },
    methods: {
        moment() {
            return moment()
        },
        stationName(group) {
            const station = this.GROUPS.find((item) => item.value === group)
            return station ? station.name : ''
        },
        async onGroupChange(item, event) {
            const next = Number(event.target.value)
            if (next === Number(item.group)) {
                return
            }
            try {
                await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.SetRecipientGroup}`, {
                    id: item._id,
                    group: next,
                })
            } catch (error) {
                event.target.value = item.group
            }
        },
        sentToZup(item) {
            const profile = item.profile
            return Boolean(profile && typeof profile === 'object' && profile.sent_to_zup)
        },
        recipientName(item) {
            const profile = item.profile
            if (!profile || typeof profile !== 'object') {
                return ''
            }
            return [profile.lastname, profile.firstname, profile.patronymic].filter(Boolean).join(' ')
        },
        creatorName(item) {
            const author = item.created_by || {}
            return [author.firstname, author.lastname].filter(Boolean).join(' ')
        },
        creatorPhoto(item) {
            const photo = item.created_by && item.created_by.photo
            if (!photo) {
                return ''
            }
            const path = photo.sm_path || photo.path
            if (!path) {
                return ''
            }
            if (/^https?:\/\//.test(path)) {
                return path
            }
            return `${process.env.VUE_APP_BASE_URL}/${String(path).replace(/^\.\//, '')}`
        },
        rowNumber(index) {
            return (this.currentPage - 1) * this.perPage + index + 1
        },
        setPages(payload) {
            if (!payload) {
                this.totalPages = 0
                return
            }
            const total = payload.query_total != null ? payload.query_total : payload.total
            const perPage = Number(payload.per_page) || this.perPage
            this.totalPages = Math.ceil((Number(total) || 0) / perPage)
        },
        async onLoad({ per_page, page, filters }) {
            const body = await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.GetRecipients}`, {params: { per_page, page: page - 1, ...filters }})
            this.setPages(body && body.data)
        },
        onPageChange(page) {
            this.currentPage = page
            this.reload()
        },
        async onSearch({ search, params }) {
            const body = await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.FindRecipient}`, { search, params })
            this.setPages(body && body.data)
        },
        reload() {
            if (String(this.search || '').trim()) {
                return this.onSearch({
                    search: this.search,
                    params: { ...this.filters, page: this.currentPage - 1, per_page: this.perPage },
                })
            }
            return this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
        },
    },
    async mounted() {
        await this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
    },
    beforeDestroy() {
        this.$store.commit(`${RecipientsNameSpace}/${RecipientsMutationTypes.SetEmptyRecipients}`)
    },
    watch: {
        filters: {
            async handler() {
                this.currentPage = 1
                await this.reload()
            },
            deep: true,
        },
        search: {
            async handler() {
                this.currentPage = 1
                await this.reload()
            },
        }
    }
}
</script>